import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { GroupView } from "@shared/models/analytics/group"
import type { Group } from "@shared/models/group"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"

interface Payload {
  group: Group
}

export default function groupViewAction(payload: Payload): PreparedAction {
  return {
    name: "GROUP_VIEW",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let primaryObjectSpecifier: "school" | "school_network"
  if (payload.group.attributes.usedAs === "school-network") {
    primaryObjectSpecifier = "school_network"
  } else {
    primaryObjectSpecifier = "school"
  }

  let newEvent: GroupView = {
    ...createBlankEvent(),
    root_id: payload.group.id,
    root_type: "group",
    date_plan_scheduled_for: null,

    primary_verb: "view",
    primary_possessive: "owns",

    primary_object_type: "group",
    primary_object_id: payload.group.id,
    primary_object_specifier: primaryObjectSpecifier,
    primary_object_id_and_ancestor_ids: [payload.group.id],

    adverbial_verb: null,

    adverbial_object_type: null,
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: [payload.group.id],
  }

  return {
    title: "User viewed group",
    titleForAnalytics: null,
    description: `Viewed the ${payload.group.attributes.usedAs} group: ${payload.group.attributes.title}`,
    context: {
      groupId: payload.group.id,
      groupUsedAs: payload.group.attributes.usedAs,
    },
    activity: null,
    newAnalyticsEvents: [newEvent],
  }
}
